module.exports = __webpack_public_path__ + "static/paul-s-ff1655d186ad3a164acbfef63754d177.png";